module.exports = __webpack_public_path__ + "img/kubernetes.2e2e359c.svg";